// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapse-transition{transition:height .15s ease-in-out,padding-top .15s ease-in-out,padding-bottom .15s ease-in-out}.collapse-transition-enter-active,.collapse-transition-leave-active{transition:max-height .15s ease-in-out,padding-top .15s ease-in-out,padding-bottom .15s ease-in-out}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
